import * as React from 'react';
var INIT_PAGE_NUM = 1;
export var usePagination = function (initPageNum) {
    var _a = React.useState(initPageNum || INIT_PAGE_NUM), pageNum = _a[0], setPageNum = _a[1];
    var goPrev = React.useCallback(function () {
        if (pageNum === INIT_PAGE_NUM)
            return;
        setPageNum(function (val) { return val - 1; });
    }, [pageNum]);
    var goNext = React.useCallback(function () {
        setPageNum(function (val) { return val + 1; });
    }, []);
    var setPage = React.useCallback(function (num) {
        setPageNum(num);
    }, [setPageNum]);
    var resetPage = React.useCallback(function () {
        setPageNum(INIT_PAGE_NUM);
    }, []);
    React.useEffect(function () {
        if (initPageNum)
            setPageNum(initPageNum);
    }, [initPageNum]);
    return {
        pageNum: pageNum,
        goNext: goNext,
        goPrev: goPrev,
        resetPage: resetPage,
        setPage: setPage,
    };
};
